import * as React from "react";
import TeacherPortalStudentModal from "./StudentModal";
const TeacherPortalStudentRow = ({ student, quizesOfStudent, activities, activitiesWithUsageData }) => {
    const [showingModal, setShowingModal] = React.useState(false);
    return <>
        {
            showingModal &&
            <TeacherPortalStudentModal student={student} activities={activities} quizesOfStudent={quizesOfStudent.quizes ? quizesOfStudent.quizes : []} onClose={() => setShowingModal(false)} activitiesWithUsageData={activitiesWithUsageData} />
        }
        <tr
            className="cursor-pointer hover:bg-black/5"
            onClick={() => setShowingModal(true)}

        >
            <td className="p-4 border-b border-black/10">
                {student.user.firstname + " " + student.user.lastname}
            </td>
            <td className="p-4 border-b border-black/10">
                {quizesOfStudent.averageScore ? Math.round(((quizesOfStudent.averageScore * 9 + 1) * 10)) / 10 : "No quizes made"}
            </td>
            <td className="p-4 border-b border-black/10">
                {new Date(student.lastLearningMaterialInteractionMoment).toDateString()}
            </td>
            <td className="p-4 border-b border-black/10">
                {student.amountOfLearningMaterialsUsed}
            </td>
            <td className="p-4 border-b border-black/10">
                {student.sumOfLearningMaterialInteractionEventCounts}
            </td>
        </tr>
    </>
}


export default TeacherPortalStudentRow